import { useEffect, useState, useContext, useMemo, useCallback } from "react";
import { formatDateToDDMMYYYY, formatMoney } from "../../../../utils/FormatUtils";
import { AppContext } from "../../../../appContext/AppContext";
import {
  CODE,
  DEFAULT_PAGE_INDEX,
  MAX_PAGE_SIZE,
  SELECTION_MODE,
  TYPE_WH,
  TYPE
} from "../../../../utils/Constant";
import { toast } from "react-toastify";
import { getDsThuocXuatKho } from "../../../../phan-he-xuat-kho/services/servicesXuatKho";
import { Col, Row } from "react-bootstrap";
import { columnsBn } from "../../../constants/TongHopPhieuColumns";
import OctTableCollapse from "../../../../component/table/table-collapse-custom/OctTableCollapse";
import { useFormikContext } from "formik";
import { PhieuXuat } from "../../../../phan-he-xuat-kho/models/XuatKhoModel";
import { TableCustom } from "../../../../component/table/table-custom/TableCustom";
import {HOAN_TRA_DVKT, PHIEU_TONGHOP_DS} from "../../../Constant";
import { WMS_STATUS } from "../../../../phan-he-nhap-kho/constants/constansNhapKho";
import { TableCustomCell } from "../../../../component/table/components/TableCustomCell";
import { Column } from "react-table";
import { TableCustomHeader } from "../../../../component/table/components/TableCustomHeader";
import {localStorageItem} from "../../../../utils/LocalStorage";
import {KEY_LOCALSTORAGE} from "../../../../auth/core/_consts";

type Props = {
  id: string;
  isView?: any;
  statusPhieu?: any;
  warehouseExportType?: any,
  warehouseId?: any,
  setIsChangeRowData: React.Dispatch<React.SetStateAction<boolean>>;
};

const ThongTinXuatThuoc = ({ id, statusPhieu, isView, warehouseExportType, warehouseId, setIsChangeRowData }: Props) => {
  const { setIsLoading } = useContext(AppContext);
  const { values, setFieldValue } = useFormikContext<PhieuXuat>();
  const [dsThuoc, setDsThuoc] = useState<any[]>([])

  useEffect(() => {
    setFieldValue("dsThuoc", dsThuoc);
  }, [dsThuoc, setFieldValue]);
  const [dsBn, setDsBn] = useState<any[]>([])
  const [totalQuantity, setTotalQuantity] = useState(0)
  const [showQuantity, setShowQuantity] = useState(false)
  const nameChild = "items"
  const isLinhBuTuTruc = warehouseExportType?.code === PHIEU_TONGHOP_DS.PLTTTT.code;
  const currentUser = localStorageItem.get(KEY_LOCALSTORAGE.authorities);

  const getVatTuXuatKho = async () => {
    setIsLoading(true);
    try {
      const payload = {
        type: warehouseExportType?.code === HOAN_TRA_DVKT.DA_TONG_HOP.code ? TYPE_WH.IMPORT : TYPE_WH.EXPORT,
        slipId: id,
        pageSize: MAX_PAGE_SIZE,
        pageIndex: DEFAULT_PAGE_INDEX,
      }
      const { data } = await getDsThuocXuatKho(payload);
      if (CODE.SUCCESS === data.code) {
        setDsThuoc(data.data.content)
      }
    } catch (error) {
      toast.error('Lỗi tải danh sách vật tư, vui lòng thử lại')
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetSelectedList = (listPatient: any) => {
    let _dsBn = listPatient?.length ? listPatient : (values?.phieuXuatKhoAdd?.listPatient ?? [])
    setDsBn(_dsBn)
    const totalQuantityCount = _dsBn?.reduce((acc: number, cur: any) => {
      let item = (cur[nameChild] ?? [])?.reduce((acc2: number, cur2: any) => acc2 + cur2?.totalQuantity, 0)

      return acc + item
    }, 0);

    setTotalQuantity(totalQuantityCount)
  }

  useEffect(() => {
    id && getVatTuXuatKho();
  }, [id]);

  useEffect(() => {
    values?.phieuXuatKhoAdd?.listPatient?.length && handleSetSelectedList(values?.phieuXuatKhoAdd?.listPatient ?? [])
  }, [values?.phieuXuatKhoAdd?.listPatient]);

  const handleChangeRowInput = useCallback((index: number, value: any, name: string, rowData: any) => {
    if (name === 'totalQuantity' && Number(value) > Number(rowData?.requireQuantity)) return
    setDsThuoc((prevDsThuoc: any) => {
      const newLstItem = [...prevDsThuoc];
      newLstItem[index] = {
        ...newLstItem[index],
        [name]: value,
      };
      return newLstItem;
    });
  }, []);

  const columnsDsThuoc: ReadonlyArray<Column<any>> = useMemo(() => [
    {
      Header: (props) => (
        <TableCustomHeader<any>
          tableProps={props}
          title="STT"
          className="text-center text-light max-w-35"
        />
      ),
      id: "stt",
      Cell: ({row}) => (
        <TableCustomCell className="text-center" data={String(row.index + 1)}/>
      ),
    },
    {
      Header: (props) => (
        <TableCustomHeader<any>
          tableProps={props}
          title="Mã thuốc"
          className="text-center spaces min-w-120"
        />
      ),
      accessor: "code",
      Cell: ({row}) => (
        <TableCustomCell data={row.original?.item?.code ?? ""}/>
      ),
    },
    {
      Header: (props) => (
        <TableCustomHeader<any>
          tableProps={props}
          title="Tên thuốc"
          className="text-center spaces min-w-200"
        />
      ),
      accessor: "item",
      Cell: ({row}) => (
        <TableCustomCell data={row.original?.item?.name ?? ""}/>
      ),
    },
    {
      Header: (props) => (
        <TableCustomHeader<any>
          tableProps={props}
          title="Số lượng"
          className="spaces min-w-80 text-center"
        />
      ),
      accessor: "requireQuantity",
      Cell: ({row}) => (
        <TableCustomCell
          className="text-end"
          data={formatMoney(isLinhBuTuTruc ? row.original?.requireQuantity : row.original?.totalQuantity) || ""}
        />
      ),
    },
    ...(isLinhBuTuTruc
        ? [
          {
            Header: (props: any) => (
              <TableCustomHeader<any>
                tableProps={props}
                title="Số lượng duyệt"
                className="spaces min-w-120 text-center"
              />
            ),
            accessor: "totalQuantity",
            Cell: ({row}: { row: any }) =>
              (currentUser?.['CIS.MODULE.WAREHOUSE.DUYET_PHIEU_TONG_HOP_DUYET'] && statusPhieu?.status === WMS_STATUS.warehouse_aggregate_slip )? (
                <input
                  className="min-w-80 w-100 border-custom-input text-end"
                  type="number"
                  value={row.original?.totalQuantity ?? ""}
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) =>
                    handleChangeRowInput(
                      row.index,
                      Number(e.target.value),
                      "totalQuantity",
                      row.original
                    )
                  }
                  onInput={() => setIsChangeRowData(true)}
                />
              ) : (
                <TableCustomCell
                  className="text-end s-2"
                  data={row.original?.totalQuantity}
                />
              ),
          },
        ]
        : []
    ),
    {
      Header: (props) => (
        <TableCustomHeader<any>
          tableProps={props}
          title="Đơn vị"
          className="spaces min-w-105 text-center"
        />
      ),
      accessor: "unitofMeasureName",
      Cell: ({row}) => (
        <TableCustomCell data={row.original?.item?.unitofMeasureName ?? ""}/>
      ),
    },

    {
      Header: (props) => (
        <TableCustomHeader<any>
          tableProps={props}
          title="Hướng dẫn sử dụng"
          className="spaces min-w-200 text-center"
        />
      ),
      accessor: "usageIns",
      Cell: ({row}) => (
        <TableCustomCell
          className="text-end"
          data={formatMoney(row.original?.item?.usageIns) || ""}
        />
      ),
    },
    {
      Header: (props) => (
        <TableCustomHeader<any>
          tableProps={props}
          title="Liều dùng"
          className="spaces min-w-200 text-center"
        />
      ),
      accessor: "lieuDung",
      Cell: ({row}) => (
        <TableCustomCell
          className="text-end"
          data={formatMoney(row.original?.lieuDung)}
        />
      ),
    },
    {
      Header: (props) => (
        <TableCustomHeader<any>
          tableProps={props}
          title="Số lô"
          className="spaces min-w-75 text-center"
        />
      ),
      accessor: "consignment",
      Cell: ({row}) => (
        <TableCustomCell data={row.original?.consignment || row.original?.item?.consignment || ""}/>
      ),
    },
    {
      Header: (props) => (
        <TableCustomHeader<any>
          tableProps={props}
          title="Hạn sử dụng"
          className="spaces min-w-120 text-center"
        />
      ),
      accessor: "expiryDate",
      Cell: ({row}) => (
        <TableCustomCell
          data={formatDateToDDMMYYYY(row.original?.expiryDate || row.original?.item?.expiryDate)}
        />
      ),
    },
  ], [setIsChangeRowData, handleChangeRowInput, statusPhieu?.status]);
  return (
    <div className="bg-white spaces mb-5 pb-15 fl-1">
      <Row lg={2}>
        <Col>
          <TableCustom
            columns={columnsDsThuoc}
            data={dsThuoc ?? []}
            selectionMode={SELECTION_MODE.SINGLE_NO_RADIO_BUTTON}
            getSelectedRowsData={(row: any) => {
              handleSetSelectedList(row?.[0]?.listPatient ?? [])
              setShowQuantity(row?.[0]?.listPatient)
            }}
          />
        </Col>
        <Col className="table-xuat-thuoc-dialog">
          <OctTableCollapse
            customFieldParent={[{ field: "patientCode" }, { field: "patientName" }, { field: "patientGenderName" }, { field: "visitCode" }, { label: "Tuổi", field: "age" }, { field: "height" }, { field: "weight" }, { field: "doCreation", type: TYPE.DATE }, { label: "MÃ ICD", field: "diagnosisCode" }, { field: "comorbidity" }]}
            data={dsBn}
            columns={columnsBn}
            searchObject={{}}
            nameChildren={nameChild}
            noAction
            noToolbar
            isLevel
            setData={(value: any) => { }}
            selectData={(value: any) => { }}
          />
          {showQuantity && <b>Tổng số lượng: {totalQuantity}</b>}
        </Col>
      </Row>
    </div>
  );
};

export default ThongTinXuatThuoc;
